import { render } from "./Related.vue?vue&type=template&id=a4d5656a&scoped=true"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"

import "./Related.vue?vue&type=style&index=0&id=a4d5656a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d5656a"]])

export default __exports__